import { Stack } from '@mui/material';

import { AvailableMarketTypesPanel, SelectedMarketTypesPanel } from './MarketPickerPanels';

const MarketPicker = () => {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ alignItems: 'stretch' }}>
      <AvailableMarketTypesPanel />
      <SelectedMarketTypesPanel />
    </Stack>
  );
};

export default MarketPicker;
